export const sendYandexEvent = (eventName: string, value: any) => {
  if (window.ym && process.env.REACT_APP_YANDEX_METRIK_KEY) {
    window.ym(process.env.REACT_APP_YANDEX_METRIK_KEY, eventName, value)
  }
};